import { Avatar } from "antd";
import moment from "moment";

const initialsFromName = (name) => {
  if (!name) return "?";
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
};

const colorFromName = (name) => {
  const palette = [
    "#1677ff",
    "#52c41a",
    "#fa8c16",
    "#eb2f96",
    "#722ed1",
    "#13c2c2",
    "#fa541c",
    "#2f54eb",
  ];
  let hash = 0;
  for (let i = 0; i < (name || "").length; i++) {
    hash = (hash << 5) - hash + name.charCodeAt(i);
    hash |= 0;
  }
  return palette[Math.abs(hash) % palette.length];
};

const CommentsSection = ({ comments }) => {
  const list = Array.isArray(comments) ? comments : [];

  return (
    <div className="comments-section" style={{ marginTop: 20 }}>
      <label
        style={{
          fontSize: 15,
          fontWeight: "bold",
          marginBottom: 12,
          display: "block",
        }}
      >
        Comments
      </label>

      {list.length === 0 ? (
        <p
          style={{
            color: "#8c8c8c",
            fontSize: 13,
            fontStyle: "italic",
            margin: "8px 0",
          }}
        >
          Belum ada comment di form ini.
        </p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {list.map((c, i) => {
            const name = c?.uid?.fullname || c?.approver?.fullname || "Unknown";
            const initials = initialsFromName(name);
            const bg = colorFromName(name);
            return (
              <div
                key={c?._id || i}
                style={{
                  display: "flex",
                  gap: 10,
                  padding: "10px 12px",
                  background: "#fafafa",
                  border: "1px solid #f0f0f0",
                  borderRadius: 6,
                }}
              >
                <Avatar
                  size={32}
                  style={{
                    backgroundColor: bg,
                    color: "#fff",
                    flexShrink: 0,
                    fontSize: 12,
                    fontWeight: 600,
                  }}
                >
                  {initials}
                </Avatar>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      flexWrap: "wrap",
                      marginBottom: 2,
                    }}
                  >
                    <span style={{ fontWeight: 600, fontSize: 13, color: "#1f1f1f" }}>
                      {name}
                    </span>
                    {c?.created_at && (
                      <span style={{ fontSize: 11, color: "#8c8c8c" }}>
                        {moment(c.created_at).format("DD MMM YYYY HH:mm")}
                      </span>
                    )}
                  </div>
                  <p
                    style={{
                      fontSize: 13,
                      lineHeight: 1.5,
                      margin: 0,
                      color: "#262626",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {c.text_plain}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CommentsSection;
